import wixLocation from 'wix-location';
import { fireBIEvent } from 'public/bi-events.js';

$w.onReady(function () {
  $w('#boxBtn').onClick(() => {
            const biFields = {
                button_name: $w('#btnLp').label,
                additional_info: 'hp bannder',
                topic: 'HP ES',
                url: wixLocation.url,
                targetUrl: $w('#btnLp').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })
});